import { render, staticRenderFns } from "./popup-batch-set-price.vue?vue&type=template&id=c9b3891c&scoped=true"
import script from "./popup-batch-set-price.vue?vue&type=script&lang=js"
export * from "./popup-batch-set-price.vue?vue&type=script&lang=js"
import style0 from "./popup-batch-set-price.vue?vue&type=style&index=0&id=c9b3891c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b3891c",
  null
  
)

export default component.exports